import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import './styles.css';
import {fromBackendDate} from '../../../utils/DateUtils';

const MONTHS = {
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    hy: ['Հուն', 'Փետ', 'Մարտ', 'Ապր', 'Մայ', 'Հուն', 'Հուլ', 'Օգս', 'Սեպ', 'Հոկ', 'Նոյ', 'Դեկ'],
};

const padTimePart = value => String(value).padStart(2, '0');

export const formatTableDateTime = (value, language = 'en') => {
    const parsedDate = fromBackendDate(value);

    if (Number.isNaN(parsedDate.getTime())) {
        return null;
    }

    const months = language === 'hy' ? MONTHS.hy : MONTHS.en;

    return {
        date: `${parsedDate.getDate()} ${months[parsedDate.getMonth()]} ${parsedDate.getFullYear()}`,
        time: `${padTimePart(parsedDate.getHours())}:${padTimePart(parsedDate.getMinutes())}:${padTimePart(parsedDate.getSeconds())}`,
    };
};

const TableDateTime = ({value, user, fallback}) => {
    const formatted = formatTableDateTime(value, user.language);

    if (!formatted) return fallback;

    return (
        <div className="table-date-time">
            <span className="table-date-time__date">{formatted.date}</span>
            <span className="table-date-time__time">{formatted.time}</span>
        </div>
    );
};

TableDateTime.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date),
    ]),
    user: PropTypes.object.isRequired,
    fallback: PropTypes.node,
};

TableDateTime.defaultProps = {
    value: null,
    fallback: '-',
};

const mapStateToProps = state => ({user: state.user});

export default connect(mapStateToProps)(TableDateTime);



// WEBPACK FOOTER //
// ./src/components-new/table/TableDateTime/index.jsx